/**
 * Calculate control title averages with caching
 * @param {Object} WebAssessmentCharts - Reference to the WebAssessmentCharts namespace
 * @param {Object} controlTitleAveragesCache - Cache object for storing calculated averages
 * @param {Object} state - State object containing areAveragesByControlTitlesCalculated
 * @returns {Object} Calculated averages by control titles
 */
function calculateControlTitleAverages(WebAssessmentCharts, controlTitleAveragesCache, state) {
	// Check if we have cached results
	if (controlTitleAveragesCache.controlTitles) {
		// console.log(`[${performance.now().toFixed(2)}] Using cached control title averages`);
		return controlTitleAveragesCache.controlTitles;
	}

	// Need to calculate
	if (!state.areAveragesByControlTitlesCalculated) {
		const startTime = performance.now();
		// console.log(`[${performance.now().toFixed(2)}] Calculating control title averages for the first time...`);
		const qualityData = WebAssessmentCharts.qualityData;
		const processedItems = WebAssessmentCharts.processedItems;

		// console.log(`[${performance.now().toFixed(2)}] Starting control titles grouping...`);
		const groupingStartTime = performance.now();
		const groupedControlTitlesByStandard = WebAssessmentCharts.groupControlTitlesByStandard(qualityData);
		// console.log(`[${performance.now().toFixed(2)}] Control titles grouped in ${(performance.now() - groupingStartTime).toFixed(2)}ms`);

		// console.log(`[${performance.now().toFixed(2)}] Starting control title averages calculation...`);
		const calculationStartTime = performance.now();
		const averagesByControlTitles = WebAssessmentCharts.calculateAverageScoresByControlTitles(processedItems, groupedControlTitlesByStandard);
		// console.log(`[${performance.now().toFixed(2)}] Control title averages calculated in ${(performance.now() - calculationStartTime).toFixed(2)}ms`);

		// Cache the results
		controlTitleAveragesCache.controlTitles = averagesByControlTitles;
		state.areAveragesByControlTitlesCalculated = true;
		const totalTime = performance.now() - startTime;
		// console.log(`[${performance.now().toFixed(2)}] Control title averages calculated and cached in ${totalTime.toFixed(2)}ms total.`);
		
		return averagesByControlTitles;
	}
	
	return controlTitleAveragesCache.controlTitles || {};
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = calculateControlTitleAverages;
} else if (typeof window !== 'undefined') {
	window.calculateControlTitleAverages = calculateControlTitleAverages;
}

